'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _env = require('../env');

/**
 * Simple GET request wrapper (for tests mainly)
 */
exports.default = {
  fetch: function fetch(url) {

    var Image = (0, _env.env)().Image;
    return new Image().src = url;
  }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/fedops-logger/dist/src/pixel/pixel.js
// module id = 467
// module chunks = 0